export const MENU_DIVIDER = null;
